import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IFavouriteItemFeature } from './favourite-item.feature.state';
import { FavouriteItemState } from './favourite-item.state';

export const getFavouriteItemState: MemoizedSelector<IFavouriteItemFeature, FavouriteItemState> = createFeatureSelector<FavouriteItemState>(
  nameof<IFavouriteItemFeature>('favouriteItemFeature')
);

export const getIsLoading = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.isLoading);
export const getFailures = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.failures);
export const getFavoriteItem = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.favoriteItems);

export const getFavouriteLocations = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.locations);
export const getFavouriteVouchers = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.vouchers);
export const getFavouriteWallets = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.wallets);

export const selectFavoriteItemsByType = (itemType: string) =>
  createSelector(
    getFavouriteItemState,
    (state) => state.favoriteItems[itemType] || [] // Ensure it returns an empty array if undefined
  );

export const selectLimitReachedByType = (itemType: string) =>
  createSelector(getFavouriteItemState, (state) => state.limitsReached[itemType]);
// export const getOrderFavouriteItem = createSelector(getFavouriteItemState, (state: FavouriteItemState) => state.orderFavouriteItem);
